import * as React from "react";
import "date-fns";
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Form, KeyValue } from "../interfaces";

const useStyles = makeStyles(() => ({
  indentedElement: {
    marginLeft: ".5rem",
  },
  radioButton: {
    "& div": {
      border: 0,
      borderRadius: "50%",
    },
  },
  formLabel: {
    height: 1,
    margin: -1,
    display: "block",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: 1,
  },
}));

export interface Props {
  fieldName: string;
  currentValue: string;
  name: string;
  ariaLabel: string;
  radioButtons: KeyValue[];
  form: Form;
  setForm: (object: any) => void;
}

export function SearchRadioButton({
  fieldName,
  setForm,
  form,
  currentValue,
  name,
  ariaLabel,
  radioButtons,
}: Props) {
  const classes = useStyles();

  const handleChange = (event: any) => {
    setForm({ ...form, [fieldName]: event.target.value });
  };
  return (
    <RadioGroup
      aria-label={ariaLabel}
      name={name}
      value={currentValue}
      onChange={e => handleChange(e)}
    >
      <FormControl component="fieldset">
        <FormLabel component="legend" className={classes.formLabel}>
          {name}
        </FormLabel>
        {radioButtons.map((button: any) => {
          return (
            <FormControlLabel
              className={classes.indentedElement}
              key={button.label}
              value={button.value}
              control={
                <Radio
                  key={button.label}
                  className={classes.radioButton}
                  color="primary"
                />
              }
              label={button.label}
            />
          );
        })}
      </FormControl>
    </RadioGroup>
  );
}
